import $ from 'jquery';
import Swiper from 'swiper/bundle';
// import cssClasses from '../helpers/cssClasses';
// TODO remove jquery
export default () => {
  function init() {
    $('.tone-slider').each(function (index, element) {
      const $this = $(this);
      $this.addClass(`tone-${index}`);
      $this.find('.swiper-button-prev').addClass(`btn-prev-${index}`);
      $this.find('.swiper-button-next').addClass(`btn-next-${index}`);

      const slideStart = $this.find('.swiper-slide').length;

      let slideCenter = '';
      let amendedSlideCenter = '';
      if (slideStart <= 2) {
        slideCenter = 1;
        amendedSlideCenter = 1;
      } else {
        slideCenter = Math.round(slideStart / 2);
        amendedSlideCenter = slideStart - 2;
      }

      console.log(
        `🎉 Skintone Swiper ${index} -- T: ${slideStart} - C: ${slideCenter} - AC: ${amendedSlideCenter}`,
      );

      let options = {};

      if ($this.find('.swiper-slide').length === 1) {
        // If only one slide, use this config
        options = {
          watchOverflow: true,
          centeredSlides: true,
          loop: false,
          pagination: false,
          navigation: false,
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 50,
            },
            960: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
            1140: {
              slidesPerView: 4,
              spaceBetween: 50,
            },
            1440: {
              slidesPerView: 5,
              spaceBetween: 30,
            },
          },
        };
      } else {
        // If multiple slides, use this config
        options = {
          spaceBetween: 30,
          slidesPerView: 1,
          watchOverflow: true,
          centeredSlides: true,
          // initialSlide: 1,
          loop: false,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
              loop: true,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 50,
            },
            960: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
            1140: {
              slidesPerView: 4,
              spaceBetween: 50,
            },
            1440: {
              slidesPerView: 5,
              spaceBetween: 30,
            },
          },
          navigation: {
            nextEl: `.btn-next-${index}`,
            prevEl: `.btn-prev-${index}`,
          },
        };
      }

      const swiper = new Swiper(`.tone-${index}`, options);

      setTimeout(() => {
        swiper.slideTo(amendedSlideCenter, false, false);
      }, 1000);

      const swiperSlidecount = swiper.slides.length - 2;
      // console.log(swiperSlidecount);
      if (swiperSlidecount < 2) {
        $this.find('.swiper-button-prev').remove();
        $this.find('.swiper-button-next').remove();
      }
    });
  }

  return Object.freeze({
    init,
  });
};
